
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulicPipe12 as ObiHydraulicPipe12Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-pipe-12.js';
 
 
 

 
 export const ObiHydraulicPipe12 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-pipe-12',
   elementClass: ObiHydraulicPipe12Element,
   events: {
     
   }
  });
 
 